import { IDiscount } from "@/modules/discount/discountModel";

/**
 * Calculates the applicable wholesale discount percentage and value based on the subtotal and active discount slabs.
 */
export const calculateWholesaleDiscount = (subtotal: number, slabs: IDiscount[]) => {
  if (!slabs || slabs.length === 0) return { percentage: 0, value: 0 };

  // Find the slab that matches the subtotal range
  const applicableSlab = slabs.find(
    (slab) => subtotal >= slab.FromValue && subtotal <= slab.ToValue
  );

  if (!applicableSlab) return { percentage: 0, value: 0 };

  const percentage = applicableSlab.DiscountPercent;
  const value = subtotal * (percentage / 100);

  return { percentage, value, slabID: applicableSlab.ID };
};

/**
 * Finds the next possible discount slab to encourage more spending.
 */
export const getNextDiscountSlab = (subtotal: number, slabs: IDiscount[]) => {
  if (!slabs || slabs.length === 0) return null;

  // Sort slabs by FromValue
  const sortedSlabs = [...slabs].sort((a, b) => a.FromValue - b.FromValue);

  // Find the first slab with FromValue > subtotal
  return sortedSlabs.find((slab) => slab.FromValue > subtotal) || null;
};
